<div [ngClass]="{'isLoaded' : isLoaded, 'header-collapsed': isHeaderCollapsed}" class="panel-header-container">
  <div class="header-content">
    <div class="icon-wrapper">
      <nb-icon [icon]="icon ?? ''" class="notificaions-icon" [ngClass]="{'conversations-icon' : component === 'conversations'}" pack="icomoon"></nb-icon>
      <div
        class="point"
        *ngIf="((notificationsService.unread$ | async) && component === 'notifications') || ((privateChat.unreadMessages$ | async) && component === 'conversations' )"
        [ngClass]="{'conversations' : component === 'conversations'}"></div>
    </div>
    <div class="title-wrapper">
      <h5 class="notifications-title">{{ ('view_translations.' + title) | translate }}</h5>
      <div *ngIf=" component === 'conversations' && activeItem !== 'chat'">
        <button class="btn add-btn global-transition" (click)="newConversation = !newConversation">
          <nb-icon icon="plus" pack="icomoon" class="plus"></nb-icon>
        </button>
        <app-new-conversation-search *ngIf="newConversation" (emitClose)="newConversation = false"> </app-new-conversation-search>
      </div>
    </div>
    <button (click)="close()" aria-label="Close" class="btn rounded-circle close-button d-none d-xl-flex" type="button">
      <nb-icon icon="cross" pack="icomoon"></nb-icon>
    </button>
  </div>
  <div class="categories-container d-flex" *ngIf="data?.length">
    <ng-container>
      <app-category
        (emitClickedItem)="getClickedItem($event)"
        *ngFor="let item of data; let first = first"
        [activeItem]="activeItem"
        [component]="component"
        [item]="item">
      </app-category>
    </ng-container>
  </div>
  <ng-content></ng-content>
</div>
